import { Check, X } from "lucide-react";

const paperComparison = [
  { feature: "Saves to phone contacts", paper: false, qcard: true },
  { feature: "Includes your photo", paper: false, qcard: true },
  { feature: "Can update anytime", paper: false, qcard: true },
  { feature: "Track who views it", paper: false, qcard: true },
  { feature: "Environmentally friendly", paper: false, qcard: true },
  { feature: "Cost", paper: "$50-200/year", qcard: "Free" },
];

const digitalComparison = [
  { feature: "Free tier with full features", other: "Limited", qcard: true },
  { feature: "No app required to view", other: "Sometimes", qcard: true },
  { feature: "Team directory feature", other: "Paid only", qcard: true },
  { feature: "NFC + QR + Link sharing", other: "Varies", qcard: true },
  { feature: "Simple, clean design", other: "Varies", qcard: true },
  { feature: "Price", other: "$5-20/mo", qcard: "Free" },
];

const ComparisonSection = () => {
  return (
    <section className="py-24 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-semibold mb-4">
            Why QCard?
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Modern Networking,{" "}
            <span className="text-gradient">Free & Easy</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Upgrade your professional image without upgrading your budget.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Paper Cards vs QCard */}
          <div className="bg-card rounded-3xl border border-border overflow-hidden">
            <div className="p-6 border-b border-border">
              <h3 className="text-xl font-bold text-foreground">Paper Cards vs QCard</h3>
              <p className="text-muted-foreground text-sm mt-1">Why paper is stuck in the past</p>
            </div>
            <div className="p-6">
              <div className="grid grid-cols-3 gap-4 mb-4 text-center">
                <div className="text-sm font-medium text-muted-foreground">Feature</div>
                <div className="text-sm font-medium text-muted-foreground">Paper</div>
                <div className="text-sm font-medium text-primary">QCard</div>
              </div>
              <div className="space-y-3">
                {paperComparison.map((row, index) => (
                  <div key={index} className="grid grid-cols-3 gap-4 items-center py-3 border-b border-border/50 last:border-0">
                    <span className="text-sm text-foreground">{row.feature}</span>
                    <div className="flex justify-center">
                      {typeof row.paper === 'boolean' ? (
                        row.paper ? (
                          <div className="w-6 h-6 rounded-full bg-green-500/10 flex items-center justify-center">
                            <Check className="w-4 h-4 text-green-500" />
                          </div>
                        ) : (
                          <div className="w-6 h-6 rounded-full bg-destructive/10 flex items-center justify-center">
                            <X className="w-4 h-4 text-destructive" />
                          </div>
                        )
                      ) : (
                        <span className="text-sm text-muted-foreground">{row.paper}</span>
                      )}
                    </div>
                    <div className="flex justify-center">
                      {typeof row.qcard === 'boolean' ? (
                        row.qcard ? (
                          <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center">
                            <Check className="w-4 h-4 text-primary" />
                          </div>
                        ) : (
                          <div className="w-6 h-6 rounded-full bg-destructive/10 flex items-center justify-center">
                            <X className="w-4 h-4 text-destructive" />
                          </div>
                        )
                      ) : (
                        <span className="text-sm font-semibold text-primary">{row.qcard}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Other Digital Cards vs QCard */}
          <div className="bg-card rounded-3xl border border-primary/20 overflow-hidden shadow-lg">
            <div className="gradient-primary p-6">
              <h3 className="text-xl font-bold text-white">Other Digital Cards vs QCard</h3>
              <p className="text-white/70 text-sm mt-1">The fatal flaw of competitors</p>
            </div>
            <div className="p-6">
              <div className="grid grid-cols-3 gap-4 mb-4 text-center">
                <div className="text-sm font-medium text-muted-foreground">Feature</div>
                <div className="text-sm font-medium text-muted-foreground">Others</div>
                <div className="text-sm font-medium text-primary">QCard</div>
              </div>
              <div className="space-y-3">
                {digitalComparison.map((row, index) => (
                  <div key={index} className="grid grid-cols-3 gap-4 items-center py-3 border-b border-border/50 last:border-0">
                    <span className="text-sm text-foreground">{row.feature}</span>
                    <div className="flex justify-center">
                      {typeof row.other === 'boolean' ? (
                        row.other ? (
                          <div className="w-6 h-6 rounded-full bg-green-500/10 flex items-center justify-center">
                            <Check className="w-4 h-4 text-green-500" />
                          </div>
                        ) : (
                          <div className="w-6 h-6 rounded-full bg-destructive/10 flex items-center justify-center">
                            <X className="w-4 h-4 text-destructive" />
                          </div>
                        )
                      ) : (
                        <span className="text-sm text-muted-foreground">{row.other}</span>
                      )}
                    </div>
                    <div className="flex justify-center">
                      {typeof row.qcard === 'boolean' ? (
                        row.qcard ? (
                          <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center">
                            <Check className="w-4 h-4 text-primary" />
                          </div>
                        ) : (
                          <div className="w-6 h-6 rounded-full bg-destructive/10 flex items-center justify-center">
                            <X className="w-4 h-4 text-destructive" />
                          </div>
                        )
                      ) : (
                        <span className="text-sm font-semibold text-primary">{row.qcard}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
